/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, NavLink } from 'react-router-dom';
import _ from 'lodash';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
// import PurposeContainer from './purpose/container/PurposeContainer';
// import AmountContainer from './amount/container/BasicAmountContainer';
import RequirementsTagging from './requirements/container/RequirementsTagging';
import FeesContainer from './fees/container/FeesContainer';
// import FeesTaggingContainer from './fees-tagging/container/FeesTaggingContainer';
import PurposesContainer from './purposes/container/PurposesContainer';

function PSASettingsContainer({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <NavLink
                  to="/civil-registry/settings/requirements"
                  className="nav-link btn-settings-tab border-right py-3 px-5"
                  activeClassName="selected"
                >
                  Requirements
                </NavLink>
              </li>
              {Acl(permissions, ['MANAGE CIVIL REGISTRY FEES']) && (
                <li className="nav-item">
                  <NavLink
                    to="/civil-registry/settings/fees"
                    className="nav-link btn-settings-tab border-right py-3 px-5"
                    activeClassName="selected"
                  >
                    Fees
                  </NavLink>
                </li>
              )}
              {/* {Acl(permissions, ['CIVIL REGISTRY FEES TAGGING']) && (
                <li className="nav-item">
                  <NavLink
                    to="/civil-registry/settings/fees-tagging"
                    className="nav-link btn-settings-tab border-right py-3 px-5"
                    activeClassName="selected"
                  >
                    Fees Tagging
                  </NavLink>
                </li>
              )} */}
              {Acl(permissions, ['VIEW PURPOSES GENERAL SETTINGS']) && (
                <li className="nav-item">
                  <NavLink
                    to="/civil-registry/settings/purposes"
                    className="nav-link btn-settings-tab border-right py-3 px-5"
                    activeClassName="selected"
                  >
                    Purposes
                  </NavLink>
                </li>
              )}
              {/* <li className="nav-item">
                <NavLink
                  to="/mcro/settings/birth/purpose"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('psa/settings/birth/purpose') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Purpose
                </NavLink>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="card p-0">
          <Switch>
            {/* <Route
              path={`${match.path}/birth/purpose`}
              component={PurposeContainer}
            /> */}
            {/* {Acl(permissions, ['CIVIL REGISTRY FEES TAGGING']) && (
              <Route
                path={`${match.path}/fees-tagging`}
                component={FeesTaggingContainer}
              />
            )} */}
            {Acl(permissions, ['MANAGE CIVIL REGISTRY FEES']) && (
              <Route path={`${match.path}/fees`} component={FeesContainer} />
            )}
            <Route
              path={`${match.path}/requirements`}
              component={RequirementsTagging}
            />
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/requirements`} />}
            />
            {Acl(permissions, ['VIEW PURPOSES GENERAL SETTINGS']) && (
              <Route
                path={`${match.path}/purposes`}
                component={PurposesContainer}
              />
            )}
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
}

PSASettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(PSASettingsContainer);
